<template>
  <div class="ruta col m-auto px-2">

    <div class="cabecera d-flex justify-content-between
        align-items-start align-content-strech">
      <h5>{{ seleccionado.name | truncate(30)}}</h5>
      <span class="remover-refugio" @click="quitarRuta"><i class="fa fa-trash"></i></span>
    </div>
    <hr>
    <p class="text-center">{{idioma.ida}}</p>
    <div class="acciones d-flex flex-row justify-content-evenly">
      <span><i class="fa fa-arrow-right"></i></span>
      <span><i class="fa fa-arrow-right ascenso"></i></span>
      <span><i class="fa fa-arrow-right descenso"></i></span>
      <span><i class="fa fa-clock"></i></span>
    </div>
    <div class="acciones d-flex flex-row justify-content-evenly">
      <span>{{ seleccionado.longitud | humanDistance }}</span>
      <span>{{ seleccionado.ascenso | humanDistance }}</span>
      <span>{{ seleccionado.descenso | humanDistance }}</span>
      <span>{{ seleccionado.tiempo | humanTime }} h.</span>
    </div>
    <hr>
    <p class="text-center">{{idioma.vuelta}}</p>
    <div class="acciones d-flex flex-row justify-content-evenly">
      <span><i class="fa fa-arrow-right"></i></span>
      <span><i class="fa fa-arrow-right ascenso"></i></span>
      <span><i class="fa fa-arrow-right descenso"></i></span>
      <span><i class="fa fa-clock"></i></span>
    </div>
    <div class="acciones d-flex flex-row justify-content-evenly">
      <span>{{ seleccionado.longitud | humanDistance }}</span>
      <span>{{ seleccionado.descenso | humanDistance }}</span>
      <span>{{ seleccionado.ascenso | humanDistance }}</span>
      <span>{{ seleccionado.vuelta | humanTime }} h.</span>
    </div>
    <hr>
    <div class="acciones d-flex flex-row justify-content-evenly">
      <a :href="gpx" class="btn btn-sm btn-success"><i class="fas fa-map-marked"></i></a>
      <a :href="pdf" class="btn btn-sm btn-success disabled"><i class="fa fa-file-pdf"></i></a>
      <a :href="ficha" class="btn btn-sm btn-success"><i class="fa fa-file"></i></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ruta",
  props: {
    seleccionado: Object,
    idioma: Object,
    ficha: String,
    gpx: String,
    pdf: String
  },
  methods:{
    quitarRuta() {
      this.$emit('quitarRuta', this.seleccionado);
    }
  }
}
</script>

<style>
.ruta,
.ruta + span {
  color: white;
  max-width: 320px !important;
  width: 320px !important;
  border: 1px solid #2f83b8;
  border-radius: 1rem;
  padding: .5rem;
  background-color: rgba(255, 255, 255, 0.15);
}

button.fecha {
  font-size: 1rem;
}

.remover-ruta {
  cursor: pointer;
  color: rgba(255,0,0,0.45);
}
.italic {
  background: repeating-linear-gradient(
      -45deg,
      darkgreen,
      green 5px,
      darkgreen 15px
  );
}

.ascenso {
  transform: rotate(-45deg);
}

.descenso {
  transform: rotate(45deg);
}
</style>